import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogContent.module.css';

export type DialogContentProps = ComponentPropsWithoutRef<'div'>;

export const dialogContentVariants = cva(s.content, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogContent = ({
  className,
  children,
  ...attrs
}: DialogContentProps) => {
  const { variant } = useDialog();

  return (
    <div
      className={clsx(dialogContentVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </div>
  );
};
